import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

function SortableHeader({ label, field, sortField, sortDirection, onSort }) {
  const isActive = sortField === field;

  const handleClick = () => {
    if (isActive) {
      // Toggle direction or reset
      onSort(field, sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // New field, default to ascending
      onSort(field, 'asc');
    }
  };

  return (
    <th scope="col" className="sortable-header" onClick={handleClick} aria-sort={isActive ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <div className="sortable-header-content">
        <span>{label}</span>
        <span className="sort-icon" aria-hidden="true">
          {isActive ? (
            sortDirection === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />
          ) : (
            <ChevronUp size={14} className="sort-icon-inactive" />
          )}
        </span>
      </div>
    </th>
  );
}

export default SortableHeader;
